/* eslint-disable no-param-reassign */
import { REQUEST } from '../constants/request';

export const INITIAL_LOADING_STATE = {
  loading: REQUEST.idle,
  currentRequestId: undefined,
  error: null,
};
export const checkAndSetLoading = (loaderState, action) => {
  if (loaderState.loading === REQUEST.idle) {
    loaderState.loading = REQUEST.pending;
    loaderState.currentRequestId = action.meta.requestId;
  }
};

export const checkAndSetLoadingWithId = (loaderStateMap, action, id) => {
  if (loaderStateMap[id] === undefined) {
    loaderStateMap[id] = { ...INITIAL_LOADING_STATE };
  }
  checkAndSetLoading(loaderStateMap[id], action);
};

export const resetLoading = loaderState => {
  loaderState.loading = REQUEST.idle;
  loaderState.currentRequestId = undefined;
};

export const matchRequest = (loadingState, action) =>
  loadingState?.loading === REQUEST.pending &&
  loadingState?.currentRequestId === action.meta.requestId;

export const onMatchedRequest = (
  loadingState,
  action,
  successCallback = () => {},
) => {
  if (matchRequest(loadingState, action)) {
    successCallback();
    resetLoading(loadingState);
  }
};

export const handleRequestRejection = (loadingState, action) => {
  /* prevent failed request from resetting loading state if it's not the current */
  if (!loadingState) return;

  if (
    loadingState.loading === REQUEST.pending &&
    loadingState.currentRequestId === action.meta.requestId
  ) {
    loadingState.loading = REQUEST.idle;
    loadingState.currentRequestId = undefined;

    if (action.payload) {
      loadingState.error = action.payload;
    } else {
      loadingState.error = action.error.message;
    }
  }
};
